import React, { useState } from 'react'

export default function ProjectCard(props) {
  let [project] = useState(props.project)

  return (
    <React.Fragment>
      <div key={project.id} className="card">
        <div>
          <div className="img-con">
            <img className="image" src={project.attributes.image.data.attributes.url} alt={project.attributes.title || ""} />
          </div>
          <h5 className="title">{project.attributes.title}</h5>
          <p className="content">{project.attributes.description}</p>
        </div>
      </div>
    </React.Fragment>
  )
}
